const PayType = `
  name
  numberId
  tax
  updatedAt
  cd
`;

export default PayType;
